import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { getProjectFirestopDocumentationData } from '../services/get-project-firestop-documentation-data.service';

export const loadProjectFirestopDocumentationData = createAsyncThunk(
  'firestopDocumentation/loadProjectFirestopDocumentationData',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const firestopDocumentationData =
      await getProjectFirestopDocumentationData(selectedProjectId);

    return firestopDocumentationData;
  }
);
